export default "<app-report-picking [customers]=\"customers\" (exportExcel)=\"onExportExcel($event)\"></app-report-picking>"